<template>
  <Panel class="modal-translate position-relative d-flex flex-column p-0">
    <div class="my-4 py-3 text-center modal-title">
      {{ $t('_web_conversation_translate-to', 'Translate to') }}
    </div>
    <form action="#" @submit.prevent="translateChat">
      <ul class="list-unstyled font-size-base">
        <li
          v-for="(item, index) in [notTranslateItem, ...languages]"
          :key="item.key"
        >
          <label class="d-block mb-0">
            <input
              v-model="chatLang"
              type="radio"
              name="select_translate_lang"
              class="modal-translate-radio"
              :value="item.key || ''"
              :checked="!index"
            />
            <span class="d-block px-2 py-3 modal-translate-done-icon-wrap">
              <AppIcon name="done" class="modal-translate-done-icon mx-2" />
              {{ item.nativeTitle || item.title }}
            </span>
          </label>
        </li>
      </ul>
      <div class="pb-1 text-center">
        <HeraFormBtn
          type="submit"
          :label="$t('_web_conversation_translate', 'Translate')"
          class="px-5 my-3 border-0 btn-primary align-self-center"
        />
      </div>
    </form>
  </Panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Panel from '@/components/atoms/Panel';
import AppIcon from '@/components/atoms/Icon';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';

export default {
  name: 'TranslateChatPopup',
  components: {
    AppIcon,
    HeraFormBtn,
    Panel,
  },
  props: {
    currentLang: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chatLang: this.currentLang,
      notTranslateItem: {
        key: '',
        nativeTitle: this.$t(
          '_web_conversation_do-not-translate',
          'Do not translate'
        ),
      },
    };
  },
  computed: {
    ...mapGetters(['locales']),
    languages() {
      return this.locales;
    },
  },
  methods: {
    ...mapActions(['closeModal']),
    translateChat() {
      this.closeModal();
      this.$emit('confirm', this.chatLang);
    },
  },
};
</script>

<style lang="scss">
.modal-translate {
  margin: 1px;
  border-radius: 0.3rem;
  .modal-title {
    font-size: 1.5rem;
  }

  label {
    cursor: pointer;
  }

  li {
    position: relative;
    display: block;
    .modal-translate-done-icon-wrap {
      line-height: 1.5rem;
      .modal-translate-done-icon {
        visibility: hidden;
      }
    }

    .modal-translate-radio {
      display: none;
      & ~ .modal-translate-done-icon-wrap:hover,
      &:checked ~ .modal-translate-done-icon-wrap {
        background: rgba($ph-secondary-text, 0.1);
      }
      &:checked ~ .modal-translate-done-icon-wrap .modal-translate-done-icon {
        visibility: visible;
      }
    }
  }
}
</style>
